import React, { useEffect, useState } from 'react';
import MainContainer from '../components/MainContainer';
import EmailForm from '../components/EmailForm';
import { FaRegCalendar } from "react-icons/fa";
import Button from '../components/Button';


function ContactPage() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 300);
        return () => clearTimeout(timer);
    }, [])
    return (
        <MainContainer>
            <div className={`transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                <Button
                    type='button'
                    status='idle'
                    text='Schedule a Call'
                    icon={FaRegCalendar}
                    className='flex justify-center gap-2 hidden mb-8 lg:justify-start items-center lg:flex lg:px-4 '
                    link='https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2OhvRoLbGuz5syGZxlLJURue4lNNZOX-QBcBaT4VH_AXgcwoscKokAiAm4lINc0kBFxaZpHAZ-'
                />
                <EmailForm />
            </div>
        </MainContainer>

    );
}

export default ContactPage;
